/* eslint-disable */
// @ts-nocheck

import { string } from 'yup/lib/locale'
import { custom } from 'zod'

import { Customer } from '@/interfaces/billing'
import { Category } from '@/interfaces/containerCategory'
import { formatDateForTableSeparatedDateAndTime } from '@/utils/helpers'

import CustomerAvatar from '../CustomerAvatar'

const getRegistrationDisplay = (customer: Customer): string => {
  switch (customer.registrationWay) {
    case 'Tecopos':
    case 'pos':
      return 'Punto de venta'
    case 'Tecopos-Admin':
    case 'admin':
      return 'Administración'
    case 'Tecopos-Marketplace':
      return 'Sin Terceros'
    case 'Tecopos-MarketplaceApk':
      return 'APK Sin Terceros'
    case 'Tecopos-Shop':
    case 'shop':
      return 'Tienda online'
    case 'Tecopos-ShopApk':
    case 'shopapk':
      return 'APK Tienda'
    case 'External-Thirdparty':
      return 'Externo'
    default:
      return customer.registrationWay || '-'
  }
}

const getFullNameDisplay = (customer: Customer): string => {
  const { firstName, lastName, email, path } = customer
  const hasName = firstName || lastName
  const displayName = hasName
    ? `${firstName || ''} ${lastName || ''}`.trim()
    : email || '-'

  return displayName
}

const getOrganizationDisplay = (customer: Customer): string => {
  if (!customer.organization) return '-'
  const organization = customer.organization
  return organization.trim()
}

const getPhoneDisplay = (customer: Customer): string => {
  if (!customer.phones?.find((p) => p.isMain)) return '-'
  const phone = `${customer.phones?.find((p) => p.isMain)?.codeCountry} ${customer.phones?.find((p) => p.isMain)?.number}`
  return phone.trim()
}

const getEmailDisplay = (customer: Customer): string => {
  if (!customer.email) return '-'
  const email = customer.email
  return email.trim()
}

const getIdentityDisplay = (customer: Customer): string => {
  if (!customer.ci) return '-'
  const ci = customer.ci
  return ci.trim()
}

const getSexDisplay = (customer: Customer): string => {
  switch (customer.sex) {
    case 'female':
      return 'Femenino'
    case 'male':
      return 'Masculino'
    case 'other':
      return 'Otro'
    default:
      return customer.sex || '-'
  }
}

const getBirthDateDisplay = (customer: Customer): string => {
  const { date, time } = formatDateForTableSeparatedDateAndTime(
    customer.birthAt
  )
  return customer.birthAt ? date : '-'
}

const getObservationDisplay = (costumer: Customer): string => {
  if (!costumer.observations) return '-'
  const observations = costumer.observations
  return observations.trim()
}

const getCreatedAtDisplay = (customer: Customer): string => {
  if (!customer.createdAt) return '-'
  const { date, time } = formatDateForTableSeparatedDateAndTime(
    customer.createdAt
  )
  return `${date} ${time}`
}

const getContractNumberDisplay = (customer: Customer): string => {
  if (!customer.contractNumber) return '-'
  return `${customer.contractNumber}`
}

const getCodeClientDisplay = (customer: Customer): string => {
  if (!customer.codeClient) return '-'
  return `${customer.codeClient}`
}

const getBarCodeDisplay = (customer: Customer): string => {
  if (!customer.barCode) return '-'
  return customer.barCode.trim()
}

const getClientIdentifierDisplay = (customer: Customer): string => {
  const identifier = customer?.clientIdentifier
  if (!identifier) return '-'
  return String(identifier).trim()
}

const getCategoriesDisplay = (customer: Customer): string => {
  if (!customer.categories || customer.categories.length === 0) return '-'
  return customer.categories
    .map((cat) => (cat as unknown as Category).name)
    .join(', ')
}

const getMunicipalityDisplay = (customer: Customer): string => {
  const municipality = customer.addresses?.[0]?.municipality?.name
  if (!municipality) return '-'
  return municipality
}

const getProvinceDisplay = (customer: Customer): string => {
  const province = customer.addresses?.[0]?.province?.name
  if (!province) return '-'
  return province
}

const getAddressDisplay = (customer: Customer): string => {
  const street1 = customer.addresses?.[0]?.street_1 ?? ''
  const street2 = customer.addresses?.[0]?.street_2 ?? ''
  const city = customer.addresses?.[0]?.city ?? ''
  const displayAddress = `${street1} ${street2} ${city}`
  return displayAddress
}

export const getTableTransformers = (
  customer: Customer
): Record<string, () => string> => {
  console.log('dattaaaa---', customer)
  return {
    'Nombre y Apellidos': () => getFullNameDisplay(customer),
    Registro: () => getRegistrationDisplay(customer),
    Organización: () => getOrganizationDisplay(customer),
    Teléfono: () => getPhoneDisplay(customer),
    'Correo electrónico': () => getEmailDisplay(customer),
    'Carnet de Identidad': () => getIdentityDisplay(customer),
    Sexo: () => getSexDisplay(customer),
    Nacimiento: () => getBirthDateDisplay(customer),
    Observaciones: () => getObservationDisplay(customer),
    'Creada el': () => getCreatedAtDisplay(customer),
    'Número de Contrato': () => getContractNumberDisplay(customer),
    'Código de Cliente': () => getCodeClientDisplay(customer),
    'Código de barra': () => getBarCodeDisplay(customer),
    'Identificador de Cliente': () => getClientIdentifierDisplay(customer),
    Categorías: () => getCategoriesDisplay(customer),
    Municipio: () => getMunicipalityDisplay(customer),
    Provincia: () => getProvinceDisplay(customer),
    Dirección: () => getAddressDisplay(customer),
  }
  return {}
}
